module.exports = __webpack_public_path__ + "static/media/Instagarm.b648131d.svg";